<div>
    <h2>Resources</h2>

    <spinner *ngIf="isLoading"></spinner>
    <resource-list [resources]="resources"></resource-list>
</div>
